import { ApplianceModel } from '@common/models';

import { COMING_SOON_IMAGE } from './setDefaultImage';

// TODO: check the possibility of having an 'Image' component that handles
// the 'COMING_SOON_IMAGE' instead
export const addMockImage = (appliance: ApplianceModel): ApplianceModel => {
    if (appliance.beautyShotImageUrl || appliance.imageUrl) {
        return appliance;
    }

    return { ...appliance, beautyShotImageUrl: COMING_SOON_IMAGE, imageUrl: COMING_SOON_IMAGE };
};
